module.exports = __webpack_public_path__ + "static/media/rfsa.b4a03e74.jpg";